module.exports = __webpack_public_path__ + "img/img2.d31a12e8.jpg";